var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WheelSlider',{attrs:{"list":[
      {perspective: 'center', items: _vm.days, ref: 'day', selectedIndex: _vm.defaultDate.day - 1},
      {perspective: 'center', items: _vm.months, ref: 'month', selectedIndex: _vm.defaultDate.month - 1},
      {perspective: 'center', items: _vm.years, ref: 'year', selectedIndex: _vm.selectedYearIndex},
    ]},on:{"on-change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }